import apiClient from "services/apiClient";

async function createEditContact(data:any) {
  const res = await apiClient.post(`/admin/contact-info`, data);
  return res.data;
}

export default createEditContact;
